import { AnyAction } from '@reduxjs/toolkit'

import type { FetchStatusCommon } from 'restApi/types'

type ListingExternalCalendar = {
  id: number
  url: string
  calendar_provider_id: number
  enabled: boolean
}

export type ListingExternalCalendarsData = ListingExternalCalendar[]

type ListingExternalCalendarsState = FetchStatusCommon & {
  data: ListingExternalCalendarsData
} & {
  creating: boolean
}

const initialState: ListingExternalCalendarsState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  updated: null,
  updating: null,
  creating: null,
  submitting: null,
}

export default function reducer(
  state = initialState,
  action: AnyAction
): ListingExternalCalendarsState {
  switch (action.type) {
    case 'LISTING_EXTERNAL_CALENDARS_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_FETCH_SILENT_REJECTED': {
      return {
        ...state,
        error: action.payload,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_FETCH_SILENT_FULFILLED': {
      return {
        ...state,
        data: action.payload.data,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_CREATE_PENDING': {
      return {
        ...state,
        creating: true,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_UPDATE_PENDING': {
      return {
        ...state,
        updated: false,
        updating: true,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_CREATE_REJECTED': {
      return {
        ...state,
        creating: false,
        error: action.payload,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_SYNC_REJECTED': {
      return {
        ...state,
        error: action.payload,
      }
    }

    case 'LISTING_EXTERNAL_CALENDARS_CREATE_FULFILLED':
      return {
        ...state,
        creating: false,
        data: action.payload.data,
      }
    case 'LISTING_EXTERNAL_CALENDARS_UPDATE_FULFILLED':
      return {
        ...state,
        updating: false,
        updated: true,
      }
    case 'LISTING_EXTERNAL_CALENDARS_DELETE_FULFILLED':
    case 'LISTING_EXTERNAL_CALENDARS_SYNC_FULFILLED': {
      return {
        ...state,
        fetching: false,
        updating: false,
        data: action.payload.data,
      }
    }

    default: {
      return state
    }
  }
}
